<template>
	<div class="w-full text-gray-900 labelingBox flex flex-col" v-if="layout.dataset"
		style="min-width: 1000px; z-index: 9999999;height: 100vh;background-color: #fff;">

		<!-- Header -->
		<div class="p-5 border-b flex-shrink-0">
			<div class="flex items-center justify-between">
				<div>
					<div class="text-xs">Dataset</div>
					<div class="text-lg font-medium">{{ layout.dataset.id }}</div>
				</div>
				<button type="button"
					class="btn text-gray-900 hover:bg-blue-500 hover:text-white flex items-center py-3 text-base"
					@click="router.push('/datasets/' + layout.dataset.id); $emit('closeTools')">
					<Log-outIcon class="w-8 h-5" />
				</button>
			</div>
		</div>

		<!-- Main Content Container - Fixed height calculation -->
		<div class="flex flex-col flex-1 min-h-0">

			<!-- Tools Table Section - Exactly 50% height -->
			<div class="h-1/2 overflow-y-auto border-b flex-shrink-0">
				<div class="p-5">
					<table class="table table--sm text-xs text-left w-full">
						<tbody>

							<!-- updatedAt -->
							<tr>
								<td class="border"><span class="font-medium text-sm text-blue-500">updatedAt</span></td>
								<td class="border text-xs">api</td>
								<td class="border text-xs"><span>Updates the "UpdatedAt" field of all images in the
										dataset.<br />Required for image mosaic to work for old datasets.</span></td>
								<td class="border">
									<div v-if="!layout.action.status || layout.action.status == 'success'"
										class="py-1 rounded-md text-center bg-blue-500 text-white cursor-pointer border zoom-in w-32"
										@click="action('updatedAt')">{{ $t('Update') }}</div>
									<div v-else-if="layout.action.type == 'updatedAt'">
										<div class="py-2 w-32 text-sm text-green-500">processing...</div>
									</div>
								</td>
							</tr>

							<!-- updateSet -->
							<tr>
								<td class="border"><span class="font-medium text-sm text-blue-500">updateSet</span></td>
								<td class="border text-xs">local</td>
								<td class="border text-xs">
									<span>Assigns 'PREDETERMINED' to the field 'SET' in the images that don't have it
										assigned.</span>
								</td>
								<td class="border">
									<div v-if="!layout.action.status || layout.action.status == 'success'"
										class="py-1 rounded-md text-center bg-blue-500 text-white cursor-pointer border zoom-in w-32"
										@click="action('updateSet')">{{ $t('Update') }}</div>
									<div v-else-if="layout.action.type == 'updateSet'">
										<div class="py-2 w-32 text-sm text-green-500">processing...</div>
									</div>
								</td>
							</tr>

							<!-- updateTag -->
							<tr>
								<td class="border"><span class="font-medium text-sm text-blue-500">updateTag</span></td>
								<td class="border text-xs">local</td>
								<td class="border text-xs">
									<span>Assigns Unclassified tag to images that don't have it assigned.</span>
								</td>
								<td class="border">
									<div v-if="!layout.action.status || layout.action.status == 'success'"
										class="py-1 rounded-md text-center bg-blue-500 text-white cursor-pointer border zoom-in w-32"
										@click="action('updateTag')">{{ $t('Update') }}</div>
									<div v-else-if="layout.action.type == 'updateTag'">
										<div class="py-2 w-32 text-sm text-green-500">processing...</div>
									</div>
								</td>
							</tr>

							<!-- updateTags -->
							<tr>
								<td class="border"><span class="font-medium text-sm text-blue-500">updateTags</span></td>
								<td class="border text-xs">local</td>
								<td class="border text-xs">
									<span>Assigns empty arrays to tags and tagsContained.</span>
								</td>
								<td class="border">
									<div v-if="!layout.action.status || layout.action.status == 'success'"
										class="py-1 rounded-md text-center bg-blue-500 text-white cursor-pointer border zoom-in w-32"
										@click="action('updateTags')">{{ $t('Update') }}</div>
									<div v-else-if="layout.action.type == 'updateTags'">
										<div class="py-2 w-32 text-sm text-green-500">processing...</div>
									</div>
								</td>
							</tr>

							<!-- refreshCounters -->
							<tr>
								<td class="border"><span class="font-medium text-sm text-blue-500">refreshCounters</span>
								</td>
								<td class="border text-xs">Usapi</td>
								<td class="border text-xs">
									<span>Updates the counters for each tag in the dataset.</span>
									<div>imageCounter and annotationsCounter / trainCounter, testCounter, validationCounter
										and predeterminedCounter</div>
								</td>
								<td class="border">
									<div v-if="!layout.action.status || layout.action.status == 'success'"
										class="py-1 rounded-md text-center bg-blue-500 text-white cursor-pointer border zoom-in w-32"
										@click="action('refreshCounters')">{{ $t('Update') }}</div>
									<div v-else-if="layout.action.type == 'refreshCounters'">
										<div class="py-2 w-32 text-sm text-green-500">processing...</div>
									</div>
								</td>
							</tr>

							<!-- resetUpload -->
							<tr>
								<td class="border"><span class="font-medium text-sm text-blue-500">resetUpload</span>
								</td>
								<td class="border text-xs">local</td>
								<td class="border text-xs">
									<span>Resets the upload progress for the current dataset.</span>
								</td>
								<td class="border">
									<div v-if="!layout.action.status || layout.action.status == 'success'"
										class="py-1 rounded-md text-center bg-blue-500 text-white cursor-pointer border zoom-in w-32"
										@click="action('resetUpload')">{{ $t('Reset') }}</div>
									<div v-else-if="layout.action.type == 'resetUpload'">
										<div class="py-2 w-32 text-sm text-green-500">processing...</div>
									</div>
								</td>
							</tr>

							<!-- generateCSV -->
							<tr>
								<td class="border"><span class="font-medium text-sm text-blue-500">generateCSV</span></td>
								<td class="border text-xs">api</td>
								<td class="border text-xs">
									<span>Generates a CSV file with the dataset's images and annotations.</span>
									<div>It will be stored in firebase storage</div>
								</td>
								<td class="border">
									<template v-if="!layout.action.status || layout.action.status == 'success'">
										<div class="py-1 rounded-md text-center bg-blue-500 text-white cursor-pointer border zoom-in w-32"
											@click="action('generateCSV_manual')">{{ $t('Manual') }}</div>
										<div class="py-1 rounded-md text-center bg-blue-500 text-white cursor-pointer border zoom-in w-32 mt-1"
											@click="action('generateCSV')">{{ $t('Auto') }}</div>
										<div class="mt-1">
											<div>Test: <input type="text" class="w-12 border rounded-md p-1 text-xs ml-8"
													v-model="layout.csvDivision.validation" /></div>
											<div class="mt-2">Validation: <input type="text"
													class="w-12 border rounded-md p-1 text-xs ml-1"
													v-model="layout.csvDivision.validation" /></div>
										</div>
									</template>
									<div
										v-else-if="layout.action.type == 'generateCSV' || layout.action.type == 'generateCSV_manual'">
										<div class="py-2 w-32 text-sm text-green-500">processing...</div>
									</div>
								</td>
							</tr>

							<!-- downloadCSV -->
							<tr>
								<td class="border"><span class="font-medium text-sm text-blue-500">downloadCSV</span></td>
								<td class="border text-xs">api</td>
								<td class="border text-xs">
									<span>Download the latest CSV file generated for the dataset.</span>
									<div>Name: {{ props.options.dataset }}.csv</div>
								</td>
								<td class="border">
									<template v-if="!layout.action.status || layout.action.status == 'success'">
										<div class="py-1 rounded-md text-center bg-blue-500 text-white cursor-pointer border zoom-in w-32"
											@click="action('downloadCSV')">{{ $t('Download') }}</div>
									</template>
									<div v-else-if="layout.action.type == 'downloadCSV'">
										<div class="py-2 w-32 text-sm text-green-500">processing...</div>
									</div>
								</td>
							</tr>

							<!-- deleteImages -->
							<tr>
								<td class="border"><span class="font-medium text-sm text-blue-500">deleteImages</span></td>
								<td class="border text-xs">local</td>
								<td class="border text-xs">
									<span>Deletes images from dataset.</span>
								</td>
								<td class="border">
									<div v-if="!layout.action.status || layout.action.status == 'success'"
										class="py-1 rounded-md text-center bg-blue-500 text-white cursor-pointer border zoom-in w-32"
										@click="action('deleteImages')">{{ $t('Delete') }}</div>
									<div v-else-if="layout.action.type == 'deleteImages'">
										<div class="py-2 w-32 text-sm text-green-500">processing...</div>
									</div>
									<div>Date: <input type="date" class="w-30 border rounded-md p-1 text-xs ml-8"
											v-model="layout.date" /></div>
								</td>
							</tr>

							<!-- deleteStorageImages -->
							<tr>
								<td class="border"><span
										class="font-medium text-sm text-blue-500">deleteStorageImages</span></td>
								<td class="border text-xs">local</td>
								<td class="border text-xs">
									<span>Deletes images from storage.</span>
								</td>
								<td class="border">
									<div v-if="!layout.action.status || layout.action.status == 'success'"
										class="py-1 rounded-md text-center bg-blue-500 text-white cursor-pointer border zoom-in w-32"
										@click="action('deleteStorageImages')">{{ $t('Delete') }}</div>
									<div v-else-if="layout.action.type == 'deleteStorageImages'">
										<div class="py-2 w-32 text-sm text-green-500">processing...</div>
									</div>
								</td>
							</tr>

						</tbody>
					</table>
				</div>
			</div>

			<!-- Terminal Section - Exactly 50% height -->
			<div class="h-1/2 flex flex-col flex-shrink-0">
				<!-- Terminal Header -->
				<div class="text-sm bg-black text-white p-5 pt-3 pb-3 flex-shrink-0">
					Console
					<span v-if="layout.action"><span class="text-yellow-500 ml-8">{{ layout.action.type }}</span></span>
					<span v-else><span class="text-yellow-500 ml-8">get</span></span>
				</div>

				<!-- Terminal Content -->
				<div class="flex-1 overflow-y-auto bg-black text-white px-5 align-top min-h-0"
					style="-ms-overflow-style: none; scrollbar-width: none;">
					<pre v-if="layout.action.resp" class="text-xs p-5">{{ layout.action.resp }}</pre>
					<div v-else-if="layout.action.status" class="text-sm p-5 text-green-500 text-left">
						Start: {{ layout.action.startAt }}<br />{{ layout.action.status }}
					</div>
					<pre v-else class="text-xs p-5">{{ layout.dataset }}</pre>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { defineComponent, onMounted, ref, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import cash from "cash-dom";

import * as rosepetalModel from "rosepetal-model";
import config from '@/etc/rosepetal.json';

let $dataset = rosepetalModel.default.dataset;
let $image = rosepetalModel.default.image;
let $model = rosepetalModel.default.model;

export default defineComponent({
	props: {
		options: {
			type: Object,
			required: true
		},
	},

	created() {
		this.helper = rosepetalModel.default.helper
	},

	setup(props) {
		const router = useRouter();
		const layout = ref({
			dataset: false,
			action: false,
			csvDivision: {
				method: "auto",
				test: 10,
				validation: 10
			},
			date: false,
		});

		const load = async () => {
			layout.value.dataset = await $dataset.get(props.options.dataset);
			layout.value.dataset.tagsCounter = await $dataset.getTagStats(layout.value.dataset);
			layout.value.dataset.dataDivision = await $dataset.getDivisionStats(layout.value.dataset);
		}

		const action = async (type) => {
			layout.value.action = { type: type, status: 'processing...', startAt: new Date() }

			switch (type) {

				case 'updatedAt':
					layout.value.action.resp = await $dataset.setImagesUpdatedDate(props.options.dataset);
					layout.value.action.status = "success";
					break;

				case 'refreshCounters':
					$dataset.refreshCounters(props.options.dataset, config.functions.usapi).then(() => {
						layout.value.action.resp = { status: "success" };
						layout.value.action.status = "success";
					});
					break;

				case 'resetUpload': {
					const data = {
						uploadResume: {
							processedImages: 0,
							status: 'finished',
							totalImages: 0
						}
					}
					$dataset.update(layout.value.dataset.id, data).then(() => {
						layout.value.action.resp = { status: "success" };
						layout.value.action.status = "success";
					});
					break;
				}

				case 'generateCSV':
					$model.getVertexCsv(props.options.dataset, layout.value.csvDivision).then(() => {
						layout.value.action.resp = { status: "success" };
						layout.value.action.status = "success";
					});
					break;

				case 'generateCSV_manual':
					$model.getVertexCsv(props.options.dataset).then(() => {
						layout.value.action.resp = { status: "success" };
						layout.value.action.status = "success";
					});
					break;

				case 'downloadCSV':
					$model.downloadVertexCsv(props.options.dataset, config.firebaseConfig.projectId).then((resp) => {
						layout.value.action.resp = { status: "success", csv: resp.csv };
						layout.value.action.status = "success";
						if (resp.status == "success" && resp.csv) window.open(resp.csv, '_blank');
					});
					break;

				case 'updateSet': {
					const dsImages = await $dataset.getImages(layout.value.dataset)
					let imageIdsWithoutSet = 0;
					dsImages.media.forEach(image => {
						if (!image.set) {
							imageIdsWithoutSet += 1;
							$image.setSet(image.id, "PREDETERMINED");
						}
					});
					layout.value.action.resp = { status: "success", imagesUpdated: imageIdsWithoutSet };
					layout.value.action.status = "success";
					break;
				}

				case 'updateTag': {
					const dsImages = await $dataset.getImages(layout.value.dataset)
					let imageIdsWithoutTag = 0;
					dsImages.media.forEach(image => {
						if (!image.tag) {
							imageIdsWithoutTag += 1;
							$image.setTag(image.id, layout.value.dataset.id, '0');
						}
					});
					layout.value.action.resp = { status: "success", imagesUpdated: imageIdsWithoutTag };
					layout.value.action.status = "success";
					break;
				}

				case 'updateTags': {
					const dsImages = await $dataset.getImages(layout.value.dataset)
					let imageIdsWithoutTag = 0;
					if (layout.value.dataset.type !== 'MULTICLASS') {
						dsImages.media.forEach(async image => {
							if (!image.tags || image.tags.length === 0) {
								imageIdsWithoutTag += 1;
								await $image.setTags(image.id, [], []);
							}
						});
					}
					layout.value.action.resp = { status: "success", imagesUpdated: imageIdsWithoutTag };
					layout.value.action.status = "success";
					break;
				}

				case 'deleteImages': {
					const cutoffDate = new Date(layout.value.date);

					let imgCounter = 0;
					const totalImgs = 50000;
					const cutoffImgs = 0;
					const queryImgs = 2500;

					const ciclos = Math.ceil(totalImgs / (queryImgs - cutoffImgs));

					for (let cycle = 0; cycle < ciclos; cycle++) {
						const dsImages = await $dataset.getJustImages(layout.value.dataset, queryImgs);
						console.log("Images obtained");

						console.time("deleteImages");
						const selectedIds = dsImages.reduce((acc, image) => {
							const parts = image.createdDate.split(' ')[0].split('/');
							const imageDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
							if (imageDate > cutoffDate) {
								acc.push(image.id);
							}
							return acc;
						}, []);

						const deletePromises = [];
						for (let i = 0; i < selectedIds.length; i += 200) {
							const batch = selectedIds.slice(i, i + 200);
							deletePromises.push(
								$dataset.deleteImagesBatch(layout.value.dataset.id, JSON.stringify(batch))
							);
						}
						await Promise.all(deletePromises);

						imgCounter += selectedIds.length;
						console.log("Deleted batch with", selectedIds.length, "images");
						console.timeEnd("deleteImages");
					}

					console.log("COMPLETED");
					layout.value.action.resp = { status: "success", cutoffDate: cutoffDate, imagesDeleted: imgCounter };
					layout.value.action.status = "success";

					break;
				}

				case 'deleteStorageImages': {
					/* const datasets = await $dataset.list(); */
					const datasets = [
						'rp-class-antiguos_clasificacion'
					]
					const imgsToRemove = [];

					await Promise.all(datasets.map(async ds => {
						const dsImages = await $dataset.getJustImages(ds);
						console.log("Checking dataset:", ds, "with", dsImages.length, "images");

						const existsArr = await Promise.all(
							dsImages.map(img => $image.checkExistingImage(img.uri))
						);

						dsImages.forEach((img, idx) => {
							if (!existsArr[idx]) imgsToRemove.push(img.id);
						});

						console.log("Images to remove so far:", imgsToRemove.length);
					}));

					/* await Promise.all(
						imgsToRemove.map(id => $image.delete(id))
					);

					console.log("Deleted total images:", imgsToRemove.length); */

					layout.value.action.resp = { status: "success", imagesDeleted: imgsToRemove.length };
					layout.value.action.status = "success";

					break;
				}

				default: console.log(`No action defined for type ${type}`);
			}
		}

		onMounted(async () => {
			console.log("Tools.vue mounted")
			cash("#rpTopBarLine").hide();
			if (props.options.dataset) await load();
			cash("body").css("overflow-y", "hidden");
		});

		onUnmounted(async () => {
			cash("body").css("overflow-y", "scroll");
			cash(".wrapper-box .content").removeClass("singlemode_wrapper");
			cash("#rpTopBarLine").show();
		});

		return {
			layout,
			router,
			props,
			action,
			load,
		};
	}
});
</script>